module.exports = __webpack_public_path__ + "media/images/star-c3034501c05845502c7198f829102914.gif";